// extracted by mini-css-extract-plugin
export default {"cls1":"CitationModal-cls1_xvM","cls2":"CitationModal-cls2_lXD CitationModal-cls1_xvM"};